export const denormalize = data => {
  const fn = (allIds, byId) => {
    const result = allIds.map(id => {
      const item = { ...byId[id] };
      item.children = fn(item.sub_folders, byId);

      return item;
    });

    return result;
  };

  return fn(data.allIds, data.byId);
};

export const findByPath = (stack, neddle) => {
  let searchWords;
  if (neddle?.includes(":")) {
    searchWords = neddle?.split(":");
  } else {
    searchWords = neddle?.split("/")?.filter(i => i !== "");
  }

  const fn = (stack, index) => {
    const word = searchWords?.[index];
    const result = stack?.find(item => {
      return item.name.toLowerCase() === word?.toLowerCase();
    });
    if (!result) {
      return null;
    }
    const nextIndex = index + 1;

    if (nextIndex === searchWords.length) {
      return result;
    }
    return fn(result.children, nextIndex);
  };

  return fn(stack, 0);
};

export const getFolderIdFromName = (name, folders) => {
  const allItems = denormalize({
    allIds: folders.allIds,
    byId: folders.byId
  });
  const folder = findByPath(allItems, name);

  return folder?.id;
};

// the sidebar hides a trashed folder at its old place and renders it under
// trash instead, so the path has to be read the same way the sidebar reads it
const isHiddenAt = (folder, parent) => {
  const status = folder.status?.toLowerCase();

  if (status === "deleted") {
    return true;
  }

  return status === "intrash" && parent?.name?.toLowerCase() !== "trash";
};

// the folder's current place in the tree, as an absolute path ("/aaa/xxx").
// unlike absfolderpath this never goes stale, it is derived from the tree
export const getFolderAbsPath = (folders, folderId) => {
  const byId = folders?.byId || {};
  const target = String(folderId);

  const walk = (ids, trail, parent) => {
    for (const id of ids || []) {
      const folder = byId[id];

      if (!folder || isHiddenAt(folder, parent)) {
        continue;
      }

      const path = [...trail, folder.name];

      if (String(id) === target) {
        return path;
      }

      const found = walk(folder.sub_folders, path, folder);
      if (found) {
        return found;
      }
    }

    return null;
  };

  const path = walk(folders?.allIds, [], null);

  return path ? "/" + path.join("/") : null;
};
